/* eslint-disable react/jsx-key */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useMemo } from "react";
import {
  Space,
  Input,
  Tooltip,
  Spin,
  Popconfirm,
  message,
  Row,
  Button,
} from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import {
  capitalize,
  dateFormat,
  getUserAndPremiseId,
  serialNum,
} from "../../../utils";
import { useNavigate, useParams } from "react-router-dom";

import TableContainer from "../../../components/TableContainer";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { getAllOnboardedVehicles } from "../../../actionsMethods/cashBookingMethods";
import {
  APIs,
  getPremiseId_,
  getPremiseId,
  getToken,
} from "../../../utils/worker";
// import { ReactComponent as Edit_icon } from "../../../assests/images/edit-logo.svg";
import { ReactComponent as Audit_icon } from "../../../assests/images/SVG/audit-icon.svg";

import { ReactComponent as Scan_check } from "../../../assests/images/SVG/check.svg";

import axios from "axios";
import urls from "../../../api/urls";
import API from "../../../api";
import Heading from "../../../components/Heading";
import ProceedModal from "../../viewBookingTable/Addpacket/proceedModal";
// import ConfirmationModal from "./confirmationModal";

const { UPDATE_STAFF, GET_PACKET_CONTENTS, UPDATE_ALL_PACKETS } = urls;

// import "./style.scss";

const BagContents = () => {
  const navigate = useNavigate();
  const params = useParams();
  const token = getToken();
  const premiseId = getPremiseId();
  const getUserInfo = getUserAndPremiseId();
  const userId = getUserInfo?.userId;
  let userPremiseId = getPremiseId_();

  const [loading, setLoading] = useState(false);
  const [check, setCheck] = useState(false);

  const [currentScanNum, setcurrentScanNum] = useState([]);
  const [scannedAwbs, setScannedAwbs] = useState([]);

  const [columnsShipments, setColumnsShipments] = useState();

  const [tableData, setTableData] = useState();

  let mockData = [
    {
      bagId: 666666666,
      driverName: "Anil Kumar",
      status: "OUTSCAN",
      barcode: 23200000433,
      isBag: true,
      isShipment: null,
      barcodeStatus: "HUB-OUTSCAN",
    },
    {
      bagId: 7777777777,
      driverName: "Anil Kumar",
      status: "OUTSCAN",
      barcode: 23200000433,
      isBag: true,
      isShipment: null,
      barcodeStatus: "HUB-OUTSCAN",
    },
    {
      bagId: 8888888888,
      driverName: "Anil Kumar",
      status: "OUTSCAN",
      barcode: 23200000433,
      isBag: true,
      isShipment: null,
      barcodeStatus: "HUB-OUTSCAN",
    },
    {
      bagId: 9999999999,
      driverName: "Anil Kumar",
      status: "HUB-IN-SCANNED",
      barcode: 23200000433,
      isBag: true,
      isShipment: null,
      barcodeStatus: "HUB-OUTSCAN",
    },
  ];

  const tableColumns = [
    {
      title: "Sl No",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: 50,
      render: (a, b, idx) => serialNum(10, 1, idx),
    },
    {
      title: "Shipments",
      dataIndex: "awbNo",
      key: "awbNo",
      width: 120,
      render: (text, val, index) => {
        return (
          <>
            <span className="mr-1"> {text}</span>
            {val?.status === "HUB-IN-SCANNED" ? <Scan_check /> : null}
          </>
        );
      },
    },

    {
      title: "Service Type",
      dataIndex: "service",
      key: "service",
      width: 100,
      render: (text) => {
        return capitalize(text) || "--";
      },
    },
    {
      title: "From Hub",
      dataIndex: "fromHub",
      key: "fromHub",
      width: 120,
      render: (text) => {
        return capitalize(text) || "--";
      },
    },
    {
      title: "To Hub",
      dataIndex: "tohub",
      key: "tohub",
      width: 120,
      render: (text) => {
        return capitalize(text) || "--";
      },
    },
  ];

  useEffect(() => {
    getTableData();
  }, []);

  useEffect(() => {
    setColumnsShipments(tableColumns);
  }, []);

  useEffect(() => {
    setColumnsShipments(tableColumns);
  }, [check]);

  let barcode = "";
  let interval;

  const handleKeyDown = (event) => {
    if (interval) clearInterval(interval);
    if (event.code == "Enter") {
      if (barcode) handleStatus(barcode);
      barcode = "";
      return;
    }
    if (event.key != "Shift") barcode += event.key;
    interval = setInterval(() => (barcode = ""), 20);
  };
  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    // cleanup this component
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleBarcode = (scanned_barcode) => {
    setcurrentScanNum(parseInt(scanned_barcode));
  };

  const getTableData = async () => {
    setLoading(true);
    let response = await API.Api(
      GET_PACKET_CONTENTS + params.id
    ).getWithPremiseIdHeader();

    if (response?.status) {
      setLoading(false);
      let getcontents = response?.response?.data;
      getcontents?.packetShipments?.map((e) => {
        e["fromHub"] = getcontents?.fromHub;
        e["tohub"] = getcontents?.tohub;
        e["service"] = getcontents?.service;
      });
      setTableData(getcontents?.packetShipments);
      // setTableData(response?.response?.data?.packetShipments);
    } else {
      if (!response.status) {
        setLoading(false);
      }
    }
  };

  async function handleStatus(id) {
    setLoading(true);
    // navigate("/bag-contents");
    try {
      let response = await axios.put(
        `${APIs.baseURL}/v1/packets/scan/${id}/status/HUB-IN-SCANNED`,
        {
          status: "HUB-IN-SCANNED",
        },
        {
          headers: {
            Authorization: token,
            "SMCS-PREMISE-ID": premiseId?.split("Bearer ")[1],
            "USER-ID": userId,
          },
        }
      );

      if (response?.status === 200) {
        setScannedAwbs((prev) => [...prev, id] || null);
        message.success(id + " scanned successfully");
        getTableData();
      }
    } catch (error) {
      setLoading(false);
      message.error(error.response.data.message || "Network error");
    }
  }

  return (
    <div className="p-2">
      <Heading title="Packet Contents" />
      <h2 className="pl-1">Packet ID:{params?.id}</h2>
      <Row>
        {/* <h3 className="pl-1">
          No of Packets:<b>3</b>
        </h3> */}
        {/* <h3 className="pl-1">No of Shipments:4</h3> */}
      </Row>
      <div className="master-main-container">
        <div className="align-center space-between">
          <div className="pl-1-5 fw-600"></div>
        </div>

        <Row className="header space-between">
          {/* <h2 className="p-1">Bag ID:121212121</h2> */}
          <div className="title"> </div>
          <div className="right">
            <Input
              maxLength={14}
              placeholder="Enter barcode to scan"
              bordered
              style={{
                borderRadius: "5px",
                height: "40px",
                // width: "100%",
                margin: "15px 33px 15px -12px",
              }}
              onChange={(e) => {
                if (e.target.value.length > 6) {
                  setcurrentScanNum(parseInt(e.target.value));
                  handleStatus(e.target.value);
                }
              }}
            />
          </div>
        </Row>
        <TableContainer
          columns={columnsShipments}
          loading={loading}
          dataSource={tableData}
          pagination={false}
          scroll={{
            x: 700,
            y: 500,
          }}
        />
      </div>

      <div className="d-flex flex-end mt-1" style={{ display: "flex" }}>
        <Button
          className="save-btn"
          style={{ textAlign: "end" }}
          onClick={() => navigate("/hub-in-scan")}
          // onClick={() => navigate("/lcr-packets-scan/" + params?.id)}
          // onClick={handleOpenBag}
        >
          SUBMIT
        </Button>
      </div>
    </div>
  );
};

export default BagContents;
